import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EditorConfig } from 'ngx-simple-text-editor';
import { qmsService } from '../qms/qms.service';
import { OneQmsFileUploadService } from '../support/file-uploader/one-qms-file-upload.service';

export interface PopupData {
  title: string;
}

interface FileIconMap {
  [key: string]: string;
}

const fileIcons: FileIconMap = {
  pdf: '../../assets/img/pdf.png',
  doc: '../../assets/img/doc.png',
  docx: '../../assets/img/docx.png',
  xl: '../../assets/img/xl.png',
  xlsx: '../../assets/img/xlsx.png',
  xml: '../../assets/img/xml.png',
  jpg: '../../assets/img/jpg.png',
  bmp: '../../assets/img/pdf.png',
  jpeg: '../../assets/img/jpeg.jpg',
  png: '../../assets/img/png.png',
  csv: '../../assets/img/csv.png',
  txt: '../../assets/img/txt.png',
  mp3: '../../assets/img/mp3.png',
  mp4: '../../assets/img/mp4.jpg',
  default: '../../assets/img/default.png',
};
@Component({
  selector: 'app-oneqms-topics',
  templateUrl: './oneqms-topics.component.html',
  styleUrls: ['./oneqms-topics.component.scss'],
})

export class OneqmsTopicsComponent {

  @Input() topicData: any = {};

  popupData: PopupData = {
    title: ''
  };

  toggleCcVisibility() {
    this.isCcExpanded = false;
  }

  fileIconsArray: { extension: string, iconUrl: string }[] = Object.keys(fileIcons).map(key => ({ extension: key, iconUrl: fileIcons[key] }));

  constructor(public appService: AppService, public qmsService: qmsService, public message: messageService, public dialog: MatDialog,
    private readonly snackBar: MatSnackBar, private readonly fileUploaderService: OneQmsFileUploadService) { }

  isProcessing = false;
  receivedSection: boolean;
  sentSection: boolean;
  showMessageContent: boolean = false;
  newMail: boolean = false;
  replyMail: boolean = false;
  replyAllMail: boolean = false;
  forwardMail: boolean = false
  listOfUsers: any = [];
  isCcExpanded = false;
  isFromReadMessage: boolean = false;
  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];
  designationListDropdown: any = [];
  departmentListDropdown: any = [];
  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  communicationData: any = {};

  designationSearchText: string = '';
  departmentSearchText: string = '';
  columnSearchText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  selectBoxForDesignation() {
    this.designationListDropdown = [];
    this.designationListDropdown = this.dropDownForDesignation?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  selectBoxForDepartment() {
    this.departmentListDropdown = [];
    this.departmentListDropdown = this.dropDownForDepartment?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  removeMailIdFromNames(input: string) {
    const bracketsRegex = /\[[^\]]+\]/g;
    if (input) {
      return input.replace(bracketsRegex, '').trim();
    }
    return input;
  }

  ngOnInit() {
    this.isProcessing = true;
    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.selectBoxForDepartment();
    this.selectBoxForDesignation();
    this.displayReceivedMails();
  }

  receivedTopicsList: any = [];

  displayReceivedMails() {
    this.isProcessing = true;

    const getReceivedTopics = (data: any) => {
      data.forEach((topic: { createdByUser: string; }) => this.removeMailIdFromNames(topic.createdByUser));
      this.receivedTopicsList = data;
      this.receivedSection = true;
      this.sentSection = false;
      this.newMail = this.isFromReadMessage;
      this.replyMail = this.replyAllMail = this.forwardMail = false;
      this.isProcessing = false;
    };

    if (this.message.communicatingFrom === 'Dashboard') {
      this.appService.getOneQmsReceivedTopics().subscribe(getReceivedTopics);
    } else if (this.message.communicatingFrom === 'DOCS') {
      this.appService.getOneQmsReceivedTopicsForActivity(this.message.serviceFromDocumentsForCommunication.documentId).subscribe(getReceivedTopics);
    } else if (this.message.communicatingFrom === 'TRN') {
      this.appService.getOneQmsReceivedTopicsForActivity(this.message.serviceFromTrainingsForCommunication.trainingId).subscribe(getReceivedTopics);
    } else if (['CR', 'CAPA', 'DV', 'AU', 'IN', 'CC'].includes(this.message.communicatingFrom)) {
      this.appService.getOneQmsReceivedTopicsForActivity(this.qmsService.activityId).subscribe(getReceivedTopics);
    } else {
      this.appService.getOneQmsReceivedTopics().subscribe(getReceivedTopics);
    }
  }

  sentTopicsList: any = [];

  displaySentMails() {
    this.isProcessing = true;
    this.receivedSection = false;
    this.sentSection = true;

    const getSentTopics = (data: any) => {
      this.sentTopicsList = data;
      this.newMail = this.replyMail = this.replyAllMail = this.forwardMail = false;
      this.isProcessing = false;
    };

    if (this.message.communicatingFrom === 'Dashboard') {
      this.appService.getOneQmsSentTopics().subscribe(getSentTopics);
    } else if (this.message.communicatingFrom === 'DOCS') {
      this.appService.getOneQmsSentTopicsForActivity(this.message.serviceFromDocumentsForCommunication.documentId).subscribe(getSentTopics);
    } else if (this.message.communicatingFrom === 'TRN') {
      this.appService.getOneQmsSentTopicsForActivity(this.message.serviceFromTrainingsForCommunication.trainingId).subscribe(getSentTopics);
    } else if (['CR', 'CAPA', 'DV', 'AU', 'IN', 'CC'].includes(this.message.communicatingFrom)) {
      this.appService.getOneQmsSentTopicsForActivity(this.qmsService.activityId).subscribe(getSentTopics);
    } else {
      this.appService.getOneQmsSentTopics().subscribe(getSentTopics);
    }
  }

  topicsData: any = [];
  documents: any = [];
  latestTopicData: any = [];
  latestDocumentData: any = [];
  topicId: any = Number;
  highlight: any = Number;
  showButtons: boolean;
  openMessageContent(messageContent: any, idx: number) {
    this.highlight = idx;
    this.isProcessing = true;
    this.newMail = true;
    this.replyMail = false;
    this.replyAllMail = false;
    this.forwardMail = false;
    this.topicId = messageContent.topicId;
    this.topicsData = [];
    this.getTopicDetails();
    if (messageContent.status == 'Closed') { this.showButtons = false; } else { this.showButtons = true; }
    if (messageContent.readAlready == "N") {
      const readUnreadData = {
        topicId: messageContent.topicId,
        action: "READ",
      }
      this.markTopicAsReadUnread(readUnreadData);
    }
  }

  getTopicDetails() {
    this.appService.getQmsTopicDetailsByTopicId(this.topicId).subscribe((data: any) => {
      data.forEach((item: any, index: any) => {
        const toUsersWithoutExtraCommas = item.toUsers.replace(/,+$/, '').replace(/^,/, '');
        const ccUsersWithoutExtraCommas = item.ccUsers.replace(/,+$/, '').replace(/^,/, '');
        const attachmentsArray: string[] = item.attachments ? item.attachments.split(',').map((attachment: string) => attachment.trim()) : [];
        const newItem = { ...item, toUsers: toUsersWithoutExtraCommas, ccUsers: ccUsersWithoutExtraCommas, attachments: attachmentsArray };

        if (index === 0) {
          this.latestTopicData = { ...newItem };
        } else {
          this.topicsData.push({ ...newItem });
        }

        if (index === data.length - 1) {
          this.showMessageContent = true;
          this.isProcessing = false;
        }
      })
    })
  }

  markTopicAsReadUnread(readUnreadData: any) {
    this.isProcessing = true;
    this.appService.markTopicAsReadUnread(readUnreadData).subscribe({
      next: (Response: any) => {
        if (Response.resultType == 'S') {
          this.isFromReadMessage = true;
          this.displayReceivedMails();
        }
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  @ViewChild('communicationPopup', { static: true }) communicationPopup: TemplateRef<any>;
  visibleCommunicationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('searchUserPopup', { static: true }) searchUserPopup: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;

  communicationPopupConfig = {
    width: '85%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  searchUserPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  editorConfiguration: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: 'null',
    maxHeight: 'null',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: '',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['undo', 'redo'],
    ['insertImage',
      'insertVideo',
      'toggleEditorMode']]
  };

  config: EditorConfig = {
    buttons: [],
  };

  openCommunicationPopup(value: any) {
    if (value === "New") {
      [this.selectedFiles, this.toUsersArray, this.ccUsersArray, this.newMail] = [[], [], [], true];
      this.communicationData = { toUsers: "", toUserNames: "", ccUsers: "", ccUserNames: "", subject: "", content: "" };
    } else {
      this.newMail = true;
      this.replyMail = this.replyAllMail = this.forwardMail = false;
    }
    const titleMapping: Record<string, string> = { 'New': 'Raise Topic', 'Reply': 'Reply Topic', 'ReplyAll': 'ReplyAll Topic', 'Forward': 'Forward Topic', };
    this.popupData.title = titleMapping[value] ?? '';
    this.visibleCommunicationPopup = this.dialog.open(this.communicationPopup, this.communicationPopupConfig);
  }

  cancelCommunicationPopup() {
    this.visibleCommunicationPopup.close();
  }

  createTopic(communicationData: any) {
    if (this.toUsersArray.length < 1) {
      this.showSnackBar('Please select To User(s)', 'E');
    } else if (!this.communicationData.subject) {
      this.showSnackBar('Please enter the Subject', 'E');
    } else if (!this.communicationData.content) {
      this.showSnackBar('Please enter the Content', 'E');
    } else {
      this.isProcessing = true;
      communicationData.subject = this.communicationData.subject;
      communicationData.content = this.communicationData.content;
      communicationData.toUsers = this.toUsersArray?.map((user: any) => user.toUserId).join(',');
      communicationData.ccUsers = this.ccUsersArray?.map((user: any) => user.ccUserId).join(',') ?? null;
      const moduleMapping: Record<string, string | null> = {
        'CR': this.qmsService.moduleName, 'CAPA': this.qmsService.moduleName, 'DV': this.qmsService.moduleName, 'AU': this.qmsService.moduleName,
        'IN': this.qmsService.moduleName, 'QI': this.qmsService.moduleName, 'CC': this.qmsService.moduleName, 'DOCS': 'DOCS', 'TRN': 'TRN', 'Dashboard': null
      };
      communicationData.moduleName = moduleMapping[this.message.communicatingFrom] ?? null;
      const taskNoMapping: Record<string, string | null> = {
        'CR': this.qmsService.activityId, 'CAPA': this.qmsService.activityId, 'DV': this.qmsService.activityId, 'AU': this.qmsService.activityId,
        'IN': this.qmsService.activityId, 'QI': this.qmsService.activityId, 'CC': this.qmsService.activityId, 'Dashboard': null,
        'DOCS': this.message.serviceFromDocumentsForCommunication?.documentId,
        'TRN': this.message.serviceFromTrainingsForCommunication?.trainingId,
      };
      communicationData.taskNo = taskNoMapping[this.message.communicatingFrom] ?? null;
      const versionMapping: Record<string, string | null> = {
        'DOCS': this.message.serviceFromDocumentsForCommunication?.documentVersion,
        'TRN': this.message.serviceFromTrainingsForCommunication?.version, 'Dashboard': null
      };
      communicationData.version = versionMapping[this.message.communicatingFrom] ?? null;
      if (communicationData.ccUsers) {
        const toUsersArray: string[] = communicationData.toUsers?.split(',').map((user: string) => user.trim());
        const ccUsersArray: string[] = communicationData.ccUsers?.split(',').map((user: string) => user.trim());
        const filteredCcUsersArray: string[] = ccUsersArray.filter((user: string) => !toUsersArray.includes(user));
        communicationData.ccUsers = filteredCcUsersArray.join(',');
      }
      this.execute(communicationData);
    }
  }

  execute(communicationData: any) {
    this.appService.createTopic(communicationData).subscribe({
      next: (Response: any) => {
        if (Response.resultType == 'S') {
          if (this.newMail) {
            this.visibleCommunicationPopup.close();
          }
          const responseTopicId: number = +Response.resultTopicId;
          const responseTopicDetailId: number = +Response.resultTopicDetailId;
          this.selectedFiles.forEach((file, index) => {
            const fileName = file.name;
            const baseFileName = fileName.substring(0, fileName.lastIndexOf('.'));
            const fileExtension = (file.name.split('.').pop() ?? '').toLowerCase();
            const fileContent = this.selectedFiles[index];
            const attachmentParams = {
              topicId: responseTopicId,
              topicDetailId: responseTopicDetailId,
              documentName: baseFileName,
              documentExtn: fileExtension
            }
            const json = JSON.stringify(attachmentParams);
            const blob = new Blob([json], {
              type: 'application/json'
            });
            const formData = new FormData();
            formData.append('document', fileContent);
            formData.append('oneQmsTopicsDto', blob);
            this.appService.storeTopicAttachment(formData).subscribe({
              next: (Response: any) => {
                if (Response.resultType == 'S') {
                  this.visibleCommunicationPopup.close();
                  console.log("File Stored Successfully")
                } else {
                  console.log("File failed to store")
                }
                this.isProcessing = false;
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
          })
          this.receivedSection && this.displayReceivedMails(); !this.receivedSection && this.displaySentMails();
        }
        this.isProcessing = false;
        this.showSnackBar(Response.result, Response.resultType);
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  discard() {
    this.newMail = true;
    this.replyMail = false;
    this.replyAllMail = false;
    this.forwardMail = false;
  }

  openDiv(value: any) {
    let uniqueUserIds: Set<number>;
    let toUsersIdArray: string[];
    let toUserNamesArray: string[];
    let ccUsersIdArray: string[];
    let ccUserNamesArray: string[];

    this.newMail = this.replyMail = this.replyAllMail = this.forwardMail = false;
    this.communicationData.topicId = this.latestTopicData.topicId;
    [this.toUsersArray, this.ccUsersArray] = [[], []];
    this.communicationData.content = "";

    switch (value) {
      case "Reply":
        this.replyMail = true;
        this.toUsersArray.push({
          toUserId: this.latestTopicData.fromUser,
          toUserName: this.latestTopicData.fromUserName
        })
        this.communicationData.subject = this.latestTopicData.subject.includes("RE: ") ? this.latestTopicData.subject : "RE: " + this.latestTopicData.subject;
        break;
      case "ReplyAll":
        this.replyAllMail = true;
        uniqueUserIds = new Set<number>();
        toUsersIdArray = this.latestTopicData.toUsers.split(',');
        toUserNamesArray = this.latestTopicData.toUserNames.split(';');

        toUsersIdArray.forEach((toUserId: any, index: any) => {
          const userId = +toUserId;
          if (!uniqueUserIds.has(userId)) {
            uniqueUserIds.add(userId);
            this.toUsersArray.push({
              toUserId: userId,
              toUserName: toUserNamesArray[index]
            })
          }
        })

        if (!uniqueUserIds.has(this.latestTopicData.fromUser)) {
          this.toUsersArray.push({
            toUserId: this.latestTopicData.fromUser,
            toUserName: this.latestTopicData.fromUserName
          })
        }

        ccUsersIdArray = this.latestTopicData.ccUsers?.split(',');
        ccUserNamesArray = this.latestTopicData.ccUserNames?.split(';');
        ccUsersIdArray.forEach((ccUserId: any, index: any) => {
          this.ccUsersArray.push({
            ccUserId: +ccUserId,
            ccUserName: ccUserNamesArray[index]
          })
        })
        this.communicationData.subject = this.latestTopicData.subject.includes("RE: ") ? this.latestTopicData.subject : "RE: " + this.latestTopicData.subject;
        break;
      case "Forward":
        this.forwardMail = true;
        this.communicationData.subject = this.latestTopicData.subject.includes("FW: ") ? this.latestTopicData.subject : "FW: " + this.latestTopicData.subject;
        break;
    }
  }

  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByEmail: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  searchCriteriaOptions: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  users: any = [];
  searchUserParentCheckBox: boolean = false;
  currentIndex: any;
  previousIndex: any = null;
  dealingWith: any = false;
  selectedUserCriteria: any;
  showCriteriaOptions: boolean;

  openSearchUserPopup(value: any) {
    this.dealingWith = value;
    [this.searchByUserName, this.searchByFirstName, this.searchByLastName, this.searchByEmail, this.selectedUserCriteria] = [null, null, null, null, null];
    [this.searchByDesignationCode, this.searchByDepartmentCode, this.searchCriteriaOptions, this.tempToUsersArray, this.tempCcUsersArray, this.users] = [null, null, [], [], [], []];

    if (['CR', 'CAPA', 'DV', 'AU', 'IN', 'QI', 'CC', 'TRN', 'DOCS'].includes(this.message.communicatingFrom)) {

      this.showCriteriaOptions = true;
      this.searchCriteriaOptions.push('All Users');
      this.selectedUserCriteria = "All Users"

      if (this.message.communicatingFrom === 'DOCS') {
        this.searchCriteriaOptions.push('Documents Users');
      } else if (this.message.communicatingFrom === 'TRN') {
        this.searchCriteriaOptions.push('Training Users');
      } else if (['CR', 'CAPA', 'DV', 'AU', 'IN', 'QI', 'CC'].includes(this.message.communicatingFrom)) {
        this.searchCriteriaOptions.push('Group Users');
      }
    } else {
      this.showCriteriaOptions = false;
    }

    this.visibleSearchUserPopup = this.dialog.open(this.searchUserPopup, this.searchUserPopupConfig);
  }

  onSearchCriteriaChanged() { this.reset(); }

  searchUser() {
    this.isProcessing = true;
    const searchOneQmsUserVwDetails = {
      userName: this.searchByUserName ? this.searchByUserName.toUpperCase() : '',
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByEmail,
      designationCode: this.searchByDesignationCode ?? null,
      departmentCode: this.searchByDepartmentCode ?? null,
      status: "active"
    };

    const handleApiResponse = (data: any) => {

      if (this.selectedUserCriteria == "Group Users") {
        this.users = data.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
      } else {
        this.users = data.filter((x: any) => x.isActive == 'Y');
        this.users.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
      }
      this.searchUserParentCheckBox = false;
      this.isProcessing = false;
    };

    let userName = this.searchByUserName ?? "undefined";
    if (this.selectedUserCriteria == null || this.selectedUserCriteria == "All Users") {
      this.appService.getOneQmsUsersVwDetails(searchOneQmsUserVwDetails).subscribe(handleApiResponse);
    } else if (this.selectedUserCriteria == "Group Users") {
      this.appService.getQmsGroupTopicUsers(this.qmsService.selectedActivityGroupId, this.qmsService.moduleName, userName).subscribe(handleApiResponse);
    } else if (this.selectedUserCriteria == "Training Users") {
      this.appService.getModuleBasedPrivilegedUsersListForTopics('TRN', userName).subscribe(handleApiResponse);
    } else if (this.selectedUserCriteria == "Documents Users") {
      this.appService.getModuleBasedPrivilegedUsersListForTopics('DOCS', userName).subscribe(handleApiResponse);
    }
  }

  tempToUsersArray: any = [];
  toUsersArray: any = [];
  tempCcUsersArray: any = [];
  ccUsersArray: any = [];
  onParentCheckBoxChanged(e: any) {
    if (e.target.checked) {
      if (this.dealingWith == "ToUser") {
        this.tempToUsersArray = [];
      } else {
        this.tempCcUsersArray = [];
      }
      this.onParentChecked();
    } else {
      this.searchUserParentCheckBox = false;
      this.onParentUnChecked();
    }
  }

  onParentChecked() {
    for (const userDetails of this.users) {
      if (userDetails.emailAddress) {
        userDetails.searchUserChildCheckBox = true;
        const userEntry = {
          userId: userDetails.userId,
          userName: userDetails.userName + "[" + userDetails.emailAddress.toLowerCase() + "]"
        };

        if (this.dealingWith === "ToUser") {
          this.tempToUsersArray.push({ toUserId: userEntry.userId, toUserName: userEntry.userName });
        } else {
          this.tempCcUsersArray.push({ ccUserId: userEntry.userId, ccUserName: userEntry.userName });
        }
      }
    }
  }

  onParentUnChecked() {
    this.users.every((user: any) => {
      user.searchUserChildCheckBox = false; return true;
    })
    if (this.dealingWith === "ToUser") {
      this.tempToUsersArray = [];
    } else {
      this.tempCcUsersArray = [];
    }
  }

  onChildCheckBoxChanged(e: any, childData: any, idx: any) {
    if (e.target.checked) {
      childData.searchUserChildCheckBox = true;
      this.onChildChecked(childData);
    } else {
      childData.searchUserChildCheckBox = this.searchUserParentCheckBox = false;
      this.onChildUnchecked(childData);
    }
  }

  onChildChecked(checkedUser: any) {
    if (this.dealingWith == "ToUser") {
      if (!this.toUsersArray?.some((user: any) => user.toUserId === checkedUser.userId)) {
        this.tempToUsersArray.push({
          toUserId: checkedUser.userId,
          toUserName: checkedUser.userName + "[" + checkedUser.emailAddress.toLowerCase() + "]"
        })
      }
    } else if (!this.ccUsersArray?.some((user: any) => user.ccUserId === checkedUser.userId)) {
      this.tempCcUsersArray.push({
        ccUserId: checkedUser.userId,
        ccUserName: checkedUser.userName + "[" + checkedUser.emailAddress.toLowerCase() + "]"
      })
    }
    if (this.users?.every((user: any) => user.searchUserChildCheckBox)) {
      this.searchUserParentCheckBox = true;
    }
  }

  onChildUnchecked(uncheckedUser: any) {
    if (this.dealingWith == "ToUser") {
      const removal = this.tempToUsersArray?.findIndex((removableUser: any) => removableUser.toUserId == uncheckedUser.userId);
      if (removal > -1) this.tempToUsersArray?.splice(removal, 1);
    } else {
      const removal = this.tempCcUsersArray?.findIndex((removableUser: any) => removableUser.ccUserId == uncheckedUser.userId);
      if (removal > -1) this.tempCcUsersArray?.splice(removal, 1);
    }
  }

  reset() {
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByEmail = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.users = [];
  }

  getUsers() {
    if (this.dealingWith == 'ToUser') {
      this.toUsersArray.push(...this.tempToUsersArray);
    } else {
      this.ccUsersArray.push(...this.tempCcUsersArray);
    }
    this.visibleSearchUserPopup.close();
  }

  closeSearchPopup() {
    this.visibleSearchUserPopup.close();
  }

  onToUserRemoved(index: number) {
    if (index >= 0 && index < this.toUsersArray.length) {
      this.toUsersArray.splice(index, 1);
    }
  }

  onCcUserRemoved(index: number) {
    if (index >= 0 && index < this.ccUsersArray.length) {
      this.ccUsersArray.splice(index, 1);
    }
  }

  selectedFiles: File[] = [];
  attachmentData: any = {};

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  openFileDialog() {
    this.fileInput.nativeElement.click();
  }

  async onFileSelected(event: any) {

    const input = event.target as HTMLInputElement;

    if (!this.message.verifyMultipleFileSize(input, this.selectedFiles)) {
      return;
    }

    const files: FileList = event.target.files;
    const selected: File[] = [];

    if (files && files.length > 0) {

      for (const file of Array.from(files)) {

        const alreadyExists = this.selectedFiles.some(f => f.name === file.name && f.size === file.size && f.lastModified === file.lastModified);

        if (alreadyExists) {
          this.showSnackBar(`${file.name} already uploaded`, 'E');
        } else {
          selected.push(file);
        }
      }
    }

    if (selected.length === 0) {
      console.log("No new files to upload");
      return;
    }

    this.fileUploaderService.uploadMultipleFiles(selected, (res) => {

      if (res.success) {
        this.selectedFiles.push(res.file);
      } else {
        this.showSnackBar(res.response?.result, 'E');
      }

    });

    this.fileInput.nativeElement.value = '';
  }

  onFileRemoved(index: number) {
    if (index >= 0 && index < this.selectedFiles.length) {
      this.selectedFiles.splice(index, 1);
    }
  }

  getImageWhileSelection(file: File): string {
    const fileExtension = this.getFileExtension(file.name);
    return fileIcons[fileExtension] || fileIcons['default'];
  }

  getImageWhileDisplay(file: any) {
    const fileExtension = this.getFileExtension(file);
    return fileIcons[fileExtension] || fileIcons['default'];
  }

  getFileExtension(fileName: string): string {
    const parts = fileName.split('.');
    if (parts.length > 1) {
      return parts.pop()!.toLowerCase(); // Use non-null assertion operator (!)
    }
    return 'default';
  }

  downloadDocument(fullFileName: any, data: any) {
    const parts = fullFileName.split('.');
    const documentName = parts[0];
    const documentExtn = parts[1];
    const obj = {
      topicId: data.topicId,
      topicDetailId: data.topicDetailId,
      documentName: documentName,
      documentExtn: documentExtn
    }
    this.appService.downloadTopicAttachments(obj);
  }

  @ViewChild(MatMenuTrigger) contextMenuTrigger: MatMenuTrigger;

  menuTopLeftPosition = { x: '0', y: '0' }

  rightClickLabels: any = ["Mark as Read", "Mark as Unread", "Active", "Inactive"];
  rightClickMenus: any = [];
  chatData: any = {};
  onContextMenu(event: MouseEvent, item: any) {
    this.chatData = item;
    event.preventDefault();

    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';
    if (this.contextMenuTrigger.menuOpen) {
      this.contextMenuTrigger.closeMenu();
    }

    this.rightClickMenus = [];

    if (item.status === 'Active' && item.readAlready === 'Y') {
      this.rightClickMenus.push({ text: 'Mark as Unread', icons: 'fa fa-envelope' });
      this.rightClickMenus.push({ text: 'Close', icons: 'fa fa-lock' });

    } else if (item.status === 'Active' && item.readAlready === 'N') {
      this.rightClickMenus.push({ text: 'Mark as Read', icons: 'fa fa-envelope-open' });
      this.rightClickMenus.push({ text: 'Close', icons: 'fa fa-lock' });

    } else if (item.status === 'Closed') {
      this.rightClickMenus.push({ text: 'Active', icons: 'fa fa-unlock' });
    }
    this.contextMenuTrigger.menuData = { item: this.rightClickMenus };
    this.contextMenuTrigger.openMenu();
  }

  rightClickOperations(clickedButton: any) {
    if (this.isProcessing) return;

    this.isProcessing = true;
    const requestData = { topicId: this.chatData.topicId, };

    const handleResponse = (Response: any) => {
      if (Response.resultType === 'S') {
        if (this.receivedSection) {
          this.displayReceivedMails();
        } else {
          this.displaySentMails();
        }
      }
      this.isProcessing = false;
      this.showSnackBar(Response.result, Response.resultType);
    };

    if (clickedButton.text === 'Mark as Unread') {
      if (this.chatData.readAlready === 'Y') {
        this.appService.markTopicAsReadUnread({ ...requestData, action: 'UNREAD' }).subscribe(handleResponse);
      }
    } else if (clickedButton.text === 'Mark as Read') {
      this.appService.markTopicAsReadUnread({ ...requestData, action: 'READ' }).subscribe(handleResponse);
    } else if (clickedButton.text === 'Close') {
      this.appService.markTopicAsClosed(requestData).subscribe(handleResponse);
    } else if (clickedButton.text === 'Active') {
      this.appService.markTopicAsActive(requestData).subscribe(handleResponse);
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

}
